import { RendererConfig } from '../types/types';


/**
 * Default options for generating static HTML.
 *
 * @since 3.0.0
 */
export const RENDERER_DEFAULT_CONFIG: RendererConfig = {
  listTag : 'ul',
  slideTag: 'li',
};
